import './AcademicHome.css'
import ViewCard from '../../../components/ViewCard/ViewCard'
import AcademicDbView from '../AcademicDashboard/AcademicDbView/AcademicDbView'
import { ROLE_SECTIONS } from '../../../utils/sidebarURLs'


export default function AcademicHome() {
   return (
      <>
         <div className='AcademicHome-grid-container'>
            {ROLE_SECTIONS.academico.items.map(item => {
               if (item.title === 'Dashboard') return
               return < ViewCard item={item} />
            })}
         </div>
         <div>
            <AcademicDbView />
         </div>
      </>
   )
}